export function renderLifecycleContextContentTemplate({
  userExpression,
  entityType,
  schemaType,
  sourceType,
  extras
}: {
  userExpression: string
  entityType: string
  schemaType: string
  sourceType: string
  extras: string
}): string {
  return `{
      user: ${userExpression},
      entityType: '${entityType}',${schemaType}
      timestamp: now,
      sourceType: '${sourceType}' as const,
      ipAddress: auditRequestMetadata.ipAddress,
      userAgent: auditRequestMetadata.userAgent${extras}
    }`
}
